export enum MessageOwner {
  SUPPLIER = 'SUPPLIER',
  DATA_ASSET_OWNER = 'DATA_ASSET_OWNER',
}
